import { useQuery, gql } from '@apollo/client';
import { useEffect, useState } from 'react';

export const GLADLY_CHAT_BLOCK_QUERY = gql`
  query GladlyChatBlockQuery {
  config {
    gladlyChatAppId: string(name: "gladlyChatAppId")
  }
    isGladlyChatEnabled: featureFlag(
      key: "gladly-chat",
      defaultValue: false
    )
  }
`;
const GLADLY = {
  IDENTITY_TYPE: {
    EMAIL: 'EMAIL',
    MOBILE_PHONE_NUMBER: 'MOBILE_PHONE_NUMBER',
  },
};

export default function GladlyChatLoader() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);
  const { data } = useQuery(GLADLY_CHAT_BLOCK_QUERY, {
    skip: !isClient,
    fetchPolicy: 'network-only',
  });
  const gladlyAppId = data?.config?.gladlyChatAppId;
  const gladlyEnabled = data?.isGladlyChatEnabled ?? true;

  useEffect(() => {
    if (!gladlyEnabled || !gladlyAppId) return;
    const style = document.createElement('style');
    style.innerHTML = `
      body#home #gladlyChat_container {
        display: none !important;
      }

      body#home #gladlyChat_container.wasOpenedOnce {
        display: flex !important;
      }
    `;
    document.head.appendChild(style);

    window.setUserForGladly = function (digitalUserData) {
      if (!digitalUserData) return;

      const existingUser = window.Gladly?.getUser?.();
      if (existingUser) return;

      const gladlyUser = {
        name: digitalUserData.name || '',
      };

      const jwt = digitalUserData.jwtToken;
      if (jwt) {
        gladlyUser.jwt = jwt;
      } else {
        if (digitalUserData.phoneNumber) {
          gladlyUser.phoneNumber = digitalUserData.phoneNumber;
          gladlyUser.identityType = GLADLY.IDENTITY_TYPE.MOBILE_PHONE_NUMBER;
        }
        if (digitalUserData.email) {
          gladlyUser.email = digitalUserData.email;
          gladlyUser.identityType = GLADLY.IDENTITY_TYPE.EMAIL;
        }
      }

      window?.Gladly?.setUser(gladlyUser);
    };
    const gladlyConfig = { appId: gladlyAppId, autoShowButton: true };

    window?.Gladly?.init(gladlyConfig)
      .then(() => {
        const isGladlyChatOpenedOnce = sessionStorage.getItem('gladlyChatIsOpenedOnce') === 'true';
        if (isGladlyChatOpenedOnce) {
          const gladlyChatEle = document.getElementById('gladlyChat_container');
          gladlyChatEle?.classList.add('wasOpenedOnce');
        }

        window.Gladly?.on?.('sidekick:opened', () => {
          sessionStorage.setItem('gladlyChatIsOpenedOnce', 'true');
        });
        const { digitalData } = window;
        if (digitalData) {
          const user = digitalData.get?.('user');
          if (user?.jwtToken || user?.phoneNumber || user?.email) {
            window.setUserForGladly(user);
          } else {
            digitalData.subscribe?.('user', (newUser) => {
              if (newUser?.jwtToken || newUser?.phoneNumber || newUser?.email) {
                window.setUserForGladly(newUser);
              }
            });
          }
        } else {
          console.warn('digitalData is not available');
        }
      })
      .catch((err) => {
        console.error('Gladly init error:', err);
      });
  }, [gladlyEnabled, gladlyAppId]);

  return null;
}
